import { AssetSpec } from "@westpierstudio/luma/factory/PixiFactory";
import { GameServices } from "game/GameServices";
import { SignalBinding } from "type-signals";
import { devLog } from "./Misc";

export type MinimumHeightSpec = AssetSpec & {
    minimumHeight?: number
};
export const minimumHeightSpecSelector = (services: GameServices, specs: MinimumHeightSpec[]) => {
    const orderedSpecs = specs.slice().sort((a: MinimumHeightSpec, b: MinimumHeightSpec) => (a.minimumHeight || 0) - (b.minimumHeight || 0));
    let selectedSpec = orderedSpecs[0];
    //if (services.uiLayout.getScreenBoundaryInBucketSpace().height < services.resources.getSetting(`minPortraitLayoutHeight`)) return selectedSpec;
    for (const spec of orderedSpecs) {
        if (services.layout.getScreenBoundaryInBucketSpace().height >= (spec.minimumHeight || 0)) {
            selectedSpec = spec;
        }
    }
    return selectedSpec;
};

export type MinimumWidthSpec = AssetSpec & {
    minimumWidth?: number
};
export const minimumWidthSpecSelector = (services: GameServices, specs: MinimumWidthSpec[]) => {
    const orderedSpecs = specs.slice().sort((a: MinimumWidthSpec, b: MinimumWidthSpec) => (a.minimumWidth || 0) - (b.minimumWidth || 0));
    let selectedSpec = orderedSpecs[0];
    for (const spec of orderedSpecs) {
        if (services.layout.getScreenBoundaryInBucketSpace().width >= (spec.minimumWidth || 0)) {
            selectedSpec = spec;
        }
    }
    return selectedSpec;
};

export const orientationSpecSelector = (services: GameServices, landscapeSpec: any, portraitSpec: any) => {
    return services.layout.landscape ? landscapeSpec : portraitSpec;
};